// extracted by mini-css-extract-plugin
export default {"root":"styles_root__xd+MT","search":"styles_search__aAxLA","search-icon":"styles_search-icon__AFSjE","button-search":"styles_button-search__vrZ3y"};